<template>
  <div v-if="isSwitchBox" class="flex sm:justify-between flex-row gap-3">
    <section class="flex justify-start md:justify-between gap-2 md:gap-3 w-full sm:w-auto">
      <section
        class="rtl:flex-row-reverse order-1 sm:order-2 border h-9 xl:h-11 md:h-10 border-primary-gray-300 rounded-md flex items-center text-xs md:text-sm"
      >
        <button class="pl-2 focus:outline-none" :disabled="isDisabled" @click="goToPreviousOption">
          <icon icon="chevronLeft" color="primary-gray-700" height="20" />
        </button>
        <section class="flex h-8 md:h-10">
          <button
            class="text-primary-gray-700 h-full mx-auto md:ml-0 md:mr-0 px-1 items-center text-sm font-inter font-medium focus:outline-none"
          >
            <div class="truncate max-w-1.25">{{ displayedLabel(currentOption) }}</div>
          </button>
        </section>
        <button class="focus:outline-none pr-2" :disabled="isDisabled" @click="goToNextOption">
          <icon icon="chevronRight" color="primary-gray-700" height="20" />
        </button>
      </section>
    </section>
  </div>

  <div v-else class="flex items-center w-full">
    <button
      class="flex w-6 h-6 bg-primary-purple-100 text-primary-gray-500 rounded-md items-center justify-center"
      :disabled="isDisabled"
      @click="goToPreviousOption"
    >
      <span><icon icon="chevronLeft" color="primary-gray-500" /></span>
    </button>
    <div
      class="text-primary-gray-500 px-2.5 py-[3px] font-medium font-inter text-xs max-w-1.25 truncate"
    >
      {{ displayedLabel(currentOption) }}
    </div>
    <button
      class="flex w-6 h-6 bg-primary-purple-100 text-primary-gray-500 rounded-md items-center justify-center"
      :disabled="isDisabled"
      @click="goToNextOption"
    >
      <span>
        <icon icon="chevronRight" color="primary-gray-500" />
      </span>
    </button>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import icon from '@src/components/icons/icon.vue'
import { objectDeepCopy } from '@/src/utils/generalUtil'
import { isArray } from 'lodash'
const currentOption = ref(null)
const optionsList = ref([])

const props = defineProps({
  modelValue: {
    type: [String, Number, Object],
    default: null,
  },
  options: {
    type: Array,
    required: true,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  isSwitchBox: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
  reduce: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:modelValue'])
const selectedIndex = ref(0)

const goToPreviousOption = () => {
  if (selectedIndex.value > 0) {
    selectedIndex.value -= 1
  } else {
    selectedIndex.value = optionsList.value.length - 1
  }
  updateCurrentOption()
}

const goToNextOption = () => {
  if (selectedIndex.value < optionsList.value.length - 1) {
    selectedIndex.value += 1
  } else {
    selectedIndex.value = 0
  }
  updateCurrentOption()
}

const updateCurrentOption = () => {
  if (optionsList.value.length) {
    currentOption.value = optionsList.value[selectedIndex.value]
    emit('update:modelValue', currentOption.value[props.reduce])
  }
}

const updateDisplayedLabel = () => {
  if (isArray(optionsList.value)) {
    currentOption.value = optionsList.value.find((option) => option.id === props.modelValue)
  } else {
    currentOption.value = null
  }
  if (!currentOption.value && optionsList.value.length) {
    currentOption.value = optionsList.value[0]
    emit('update:modelValue', currentOption.value[props.reduce])
  }
}

const displayedLabel = (currentOption) => {
  return currentOption ? currentOption[props.label] : ''
}

watch(
  [() => props.options, () => props.modelValue],
  ([newOptions, newModelValue]) => {
    if (isArray(newOptions)) {
      optionsList.value = objectDeepCopy(newOptions)
    } else {
      optionsList.value = []
    }

    if (newModelValue || isArray(newOptions)) {
      updateDisplayedLabel()
    }
  },
  { immediate: true },
)
</script>
